<particle-dynamic-tooltip-container
  *ngIf="topics.length > 0;else emptyTopicRef"
  [component]="'DataSurveyTopicTooltipComponent'"
  [metadata]="topics"
  [theme]="'dark'">
  <p class="emphasized-cell-viewer">
    {{topics?.length}} Topics
  </p>
</particle-dynamic-tooltip-container>
<ng-template #emptyTopicRef>
  <p class="emphasized-cell-viewer">
    {{topics?.length}} Topics
  </p>
</ng-template>
